import styled from 'styled-components'

export const Wrapper = styled.div`
    /* Fixes bug when parent is grid or flex (https://github.com/akiran/react-slick/issues/1320) */
    min-width: 0;
`
